import { render } from "./AnnouncementDetails.vue?vue&type=template&id=946520fe&scoped=true"
import script from "./AnnouncementDetails.vue?vue&type=script&lang=js"
export * from "./AnnouncementDetails.vue?vue&type=script&lang=js"

import "./AnnouncementDetails.vue?vue&type=style&index=0&id=946520fe&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Jude\\Desktop\\projects\\creditclan\\clan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-946520fe"]])

export default __exports__